<template>
  <font-awesome-icon
    icon="angle-double-up"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons'

library.add(faAngleDoubleUp)

export default {
  name: 'CoozzyAngleDoubleUpIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
